<template>
  <div class="hp-base-panel-wrp hp-base-panel-wrp-new">
    <div class="consult-panel hp-base-panel">
      <div @click="emitEvent">
        <div class="top">
          <p class="good-at">
            {{ expertiseToStr }}
          </p>
          <p class="price DharmaTypeBebasKai">
            <span class="sign">¥</span>
            <span class="num">{{ price }}</span>
            <span class="times">/次</span>
          </p>
        </div>
      </div>

      <div class="discount-wrap ab-test" v-if="discount.length">
        <div class="discount">
          <template v-for="d in discount">
            <p
              :class="{
                'discount-coupon': d.frontIsCoupon
              }"
              :key="d.id"
              @click="handleDiscountClick(d)"
            >
              <span class="right">{{ d.frontDetail }} </span>
            </p>
          </template>
        </div>
        <div
          class="discount-detail"
          v-if="isShowDiscountMore"
          @click="openCouponsPopup"
        >
          <img
            class="arrow-2"
            src="~images/platform/homepage/right-arrow-2.png"
            alt=""
          />
        </div>
      </div>
      <div class="field" @click="handleWayClick">
        <div class="field-l">咨询方式</div>
        <div class="field-r">
          <p
            class="field-r-type"
            v-for="(tab, index) in parsedConsultType"
            :key="index"
          >
            {{ tab }}
          </p>
          <img
            class="arrow-2"
            src="~images/platform/homepage/right-arrow-2.png"
            alt=""
          />
        </div>
      </div>

      <div
        class="field mt40 mb0"
        @click="
          handleDateClick({ auto_show_selector: schedules.length ? 1 : 0 })
        "
      >
        <div class="field-l">可约日期</div>
        <div class="field-r">
          <p>
            <span :class="{ 'yuyue-date': isBlank(recentSchedules) }">{{
              parsedScheduleStr
            }}</span>
            <span v-if="isBlank(recentSchedules)">，查看更多</span>
          </p>
          <img
            class="arrow-2"
            src="~images/platform/homepage/right-arrow-2.png"
            alt=""
          />
        </div>
      </div>

      <img
        class="ensure"
        src="~images/platform/homepage/yxl-ensure.png"
        alt=""
        @click="isShowEnsure = true"
      />

      <ensureRuleModel :show.sync="isShowEnsure" />

      <!-- 查看优惠券弹窗 -->
      <consultCouponsPopup
        v-model="isShowCouponsPopup"
        @toOrderWithActive="handleDiscountClick"
      ></consultCouponsPopup>
    </div>
  </div>
</template>

<script>
import ensureRuleModel from 'lib/component/vue/consult/ensureRuleModel.vue'
import { EventBus } from 'component/platform/homepage/eventBus.js'
import consultCouponsPopup from './consultCouponsPopup.vue'
import { getCoupon } from 'api/platform/homepage.js'
export default {
  components: {
    ensureRuleModel,
    consultCouponsPopup
  },
  data() {
    return {
      isShowEnsure: false,
      isShowCouponsPopup: false,
      receiving: false
    }
  },
  computed: {
    price() {
      const price = this.consultServiceInfo.price
      const arr = price.split('.')
      return arr[1] === '00' ? arr[0] : price
    },
    isLogin() {
      return this.$store.getters.isLogin
    },
    consultServiceInfo() {
      return this.$store.getters['homepage/consultServiceInfo']
    },
    parsedConsultType() {
      const { consult_type = [] } = this.consultServiceInfo
      return consult_type.map(item => item.way_type_name)
    },
    schedules() {
      const { schedules = [] } = this.$store.state.homepage.zxAdvancedInfo
      return schedules
    },
    recentSchedules() {
      const {
        recent_schedules = ''
      } = this.$store.state.homepage.zxAdvancedInfo
      return recent_schedules
    },
    isShowDiscountMore() {
      const {
        coupons = [],
        packages = []
      } = this.$store.state.homepage.zxAdvancedInfo

      return [...coupons, ...packages].length > 3
    },
    discount() {
      const {
        coupons = [],
        packages = []
      } = this.$store.state.homepage.zxAdvancedInfo
      let data = []
      if (coupons.length) {
        coupons[0].frontIsCoupon = true
        data.push(coupons[0])
      }
      if (packages.length) {
        // 没有优惠券上三个活动
        data = [...data, ...packages.slice(0, data.length ? 2 : 3)]
      }

      return data.map(d => {
        const { frontIsCoupon, type, max_reduce, show_name, discount_tag } = d
        d.frontName = frontIsCoupon ? '券' : d.abbreviation || d.name
        d.frontName.length > 4 &&
          (d.frontName = `${d.frontName.slice(0, 3)}...`)
        d.frontDetail = frontIsCoupon
          ? type === 'Free'
            ? `${max_reduce}元免单券`
            : show_name
          : discount_tag

        return d
      })
    },
    parsedScheduleStr() {
      const { schedules, recentSchedules } = this
      let recentSchedulesText = ''
      if (this.isBlank(recentSchedules)) {
        recentSchedulesText = `最快可约${
          recentSchedules.date ? recentSchedules.date : ''
        }${recentSchedules.time ? recentSchedules.time : ''}`
      }
      return recentSchedulesText
        ? recentSchedulesText
        : schedules.length
        ? schedules.slice(0, 3).join('，')
        : '下单后与咨询师沟通'
    },
    // 最优折扣（已登录 & 有优惠信息才会赋值）
    minPrice() {
      const { min_price } = this.$store.state.homepage.zxAdvancedInfo
      if (min_price && min_price.id) {
        return min_price
      }
      return null
    },
    expertiseToStr() {
      return (this.consultServiceInfo.expertise || [])
        .map(e => e.category)
        .join('/')
    }
  },
  methods: {
    emitEvent(params = {}) {
      EventBus.$emit('toZxOrder', params)
    },
    handleWayClick() {
      this.$trackEvent('newprofilepages_consulttways', {})
      this.emitEvent()
    },
    handleDateClick(params) {
      this.$trackEvent('newprofilepages_consulttime', {})
      this.emitEvent(params)
    },
    showEnsure() {
      this.$trackEvent('newprofilepages_guarantee', {})
      this.isShowEnsure = true
    },
    handleDiscountClick(item) {
      if (!this.isLogin) return this.toLogin()

      if (item.frontIsCoupon) {
        // 非弹框 点击优惠券 埋点
        !item.triggerInPopup &&
          this.$trackEvent('newprofilepages_service_coupons_click', {
            coupon_id: item.id
          })
        // 未领券 去领券
        if (+item.received !== 1) return this.receiveCoupon(item)
      } else {
        const str = item.triggerInPopup
          ? 'newprofilepages_discounts_activities'
          : 'newprofilepages_service_activities_click'
        this.$trackEvent(str, { package_id: item.id })
      }
      this.toZxOrder(item)
    },
    // 下单
    toZxOrder(item) {
      let data = {}
      if (item.frontIsCoupon) {
        data = { coupon_id: item.id }
        // 弹框 点击使用优惠券 埋点
        item.triggerInPopup &&
          this.$trackEvent('newprofilepages_discounts_tousecoupon', data)
      } else {
        data = { activity_id: item.id }
        // 如果该套餐不属于【节日活动】，就跳转到对应的活动链接页面
        const { activity_type, url, id } = item
        if (id != 41 && !['normal', 'festival'].includes(activity_type) && url)
          return this.routerPush(url)
      }
      this.emitEvent(data)
    },
    // 领券
    async receiveCoupon(item) {
      if (this.receiving) return
      this.receiving = true

      getCoupon({ id: item.id })
        .then(({ code, message }) => {
          if (!+code) {
            this.$toast({
              text: '领取成功',
              zIndexTop: true
            })
            // 领取成功后，更新数据
            this.$store.dispatch('homepage/fetchConsultService', {
              user_id: this.$route.params.userId
            })
            const params = { coupon_id: item.id }
            if (item.triggerInPopup) {
              this.$trackEvent('newprofilepages_discounts_getcoupon', params)
            } else {
              this.$trackEvent('newprofilepages_getcouponssuccess', params)
              this.toZxOrder(item)
            }
          } else {
            this.$toast({
              text: message || '领取失败',
              zIndexTop: true
            })
          }
        })
        .catch(() => {
          this.$toast({
            text: '领取失败，请稍候重试',
            zIndexTop: true
          })
        })
        .finally(() => {
          this.receiving = false
        })
    },
    openCouponsPopup() {
      this.$trackEvent('newprofilepages_service_discount_more', {})
      this.isShowCouponsPopup = true
    },
    isBlank(val) {
      return (
        ((Array.isArray(val) ||
          Object.prototype.toString.call(val) === '[object Object]') &&
          JSON.stringify(val).length > 2) ||
        (typeof val == 'string' && val)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~lib/scss/functions';
.hp-base-panel-wrp {
  &.hp-base-panel-wrp-new {
    background: url('~images/platform/homepage/service-bg.png') no-repeat;
    background-size: 686px 150px;
    // background: linear-gradient(180deg, #fff7f5 0%, #fff6f5 0%, #fff7f6 100%);
    padding-top: 0;
    margin-top: 30px;
    border-radius: 30px 30px 16px 16px;
  }
  .desc {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9da3ac;
    height: 76px;
    padding: 0 30px 0 24px;
    box-sizing: border-box;
    .icon-care {
      width: 147px;
      height: 28px;
      padding-right: 10px;
      border-right: 1px solid #eaeaea;
    }
    .desc-right {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      .desc-text {
        max-width: 430px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-left: 10px;

        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #fc7a5e;
        line-height: 28px;
      }
      .arrow-3 {
        width: 13px;
        height: 13px;
        object-fit: cover;
        margin-left: 0 !important;
      }
    }
  }
}
.consult-panel {
  padding: 30px;
  position: relative;

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 35px;
    .good-at {
      width: 465px;
      @include limitLine(1);
    }
    .price {
      display: flex;
      align-items: baseline;
      span {
        color: #6982fa;
        font-weight: 400;
        &.sign {
          font-size: 30px;
          line-height: 30px;
        }
        &.num {
          font-size: 42px;
          line-height: 42px;
          margin-right: 8px;
        }
        &.times {
          font-size: 20px;
          line-height: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          color: #6982fa;
        }
      }
    }
  }

  .good-at {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 700;
    color: #21252d;
    line-height: 52px;
  }

  .price-wrap {
    display: flex;
    align-items: center;
    margin: 20px 0 34px;

    .price {
      font-size: 42px;
      color: #ffa202;
      line-height: 42px;
      font-weight: 700;
      margin-right: 10px;
      span {
        font-size: 30px;
      }
    }

    .lower-price {
      height: 32px;
      padding: 0 8px;
      background: #fff1e2;
      text-align: center;
      border-radius: 8px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ff745b;
      line-height: 32px;
    }
  }

  .price {
    color: #ffa202;
  }
  .arrow-2 {
    width: 13px;
    height: 13px;
    object-fit: cover;
    margin-left: 16px;
  }
  .ml10 {
    margin-left: 10px;
  }
  .mt40 {
    margin-top: 38px !important;
  }
  .mb0 {
    margin-bottom: 0 !important;
  }

  .field {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 30px 0;
    font-family: PingFangSC-Regular, PingFang SC;
    &:first-of-type {
      margin-top: 0;
    }
    .field-l {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #21252d;
    }
    .field-r {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #21252d;
      display: flex;
      align-items: center;
      justify-content: center;
      .field-r-type {
        padding: 10px;
        font-size: 22px;
        background: #f2f4ff;
        border-radius: 8px;
        margin-right: 10px;
      }
      .yuyue-date {
        color: #6982fa;
      }
    }
  }

  .discount-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .discount {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
      p {
        display: flex;
        border-radius: 8px;
        border: 1px solid #ffa202;
        margin: 0 8px 15px 0;
        &:last-child {
          margin-right: 0;
        }
        span {
          line-height: 42px;
          padding: 0 6px;
          font-size: 22px;
        }
        .left {
          background: #ffa202;
          color: #ffffff;
        }
        .right {
          display: flex;
          align-items: center;
          color: #ffa202;
        }
        &.discount-coupon {
          border-color: #6982fa;
          .left {
            background: #6982fa;
          }
          .right {
            color: #6982fa;
          }
        }
      }
    }
    &.ab-test {
      .discount p {
        height: 38px;
        border: 2px solid #ffa202;
        &:not(:last-child) {
          margin-right: 20px;
        }
        .right {
          font-size: 22px;
          color: #ffa202;
          line-height: 38px;
        }
      }
    }
    .discount-detail {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 90px;
      margin-bottom: 15px;
      span {
        font-size: 24px;
        color: #ffa202;
      }
    }
  }

  .ensure {
    width: 100%;
    height: 150px;
    margin-top: 40px;
  }
}
</style>
